var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"white--text font-weight-bold",attrs:{"color":"blue-grey","rounded":""},on:{"click":function($event){return _vm.getPdf()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-printer")]),_vm._v(" Imprimir")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }